module.exports = __webpack_public_path__ + "img/sisamex-blanco.1c09231e.png";